var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./select-store-uk.j2"] = require( "./select-store-uk.j2" );
dependencies["./select-store-us.j2"] = require( "./select-store-us.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/personal-stylist/select-store.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = "UK";
frame.set("UKRegionCode", t_1, true);
if(frame.topLevel) {
context.setVariable("UKRegionCode", t_1);
}
if(frame.topLevel) {
context.addExport("UKRegionCode", t_1);
}
output += "\n";
var t_2;
t_2 = "US";
frame.set("USRegionCode", t_2, true);
if(frame.topLevel) {
context.setVariable("USRegionCode", t_2);
}
if(frame.topLevel) {
context.addExport("USRegionCode", t_2);
}
output += "\n";
var t_3;
t_3 = "CA";
frame.set("CARegionCode", t_3, true);
if(frame.topLevel) {
context.setVariable("CARegionCode", t_3);
}
if(frame.topLevel) {
context.addExport("CARegionCode", t_3);
}
output += "\n\n<div class=\"o-column o-extra-small--12 o-large--8\">\n\n    <div class=\"c-form__field is-required\">\n\n        <label for=\"yourStore\" class=\"c-form__label\">\n            ";
output += runtime.suppressValue((lineno = 9, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_your-store-label"])), env.opts.autoescape);
output += "\n        </label>\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"storesForPersonalShopper")) {
output += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"isSiteOutsideNorthAmerica")) {
output += "\n                ";
env.getTemplate("./select-store-uk.j2", false, "help/templates/personal-stylist/select-store.j2", null, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n            ";
})});
}
else {
output += "\n                ";
env.getTemplate("./select-store-us.j2", false, "help/templates/personal-stylist/select-store.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n            ";
})});
}
output += "\n        ";
;
}
output += "\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/personal-stylist/select-store.j2"] , dependencies)